import React from 'react';
import { EditPage } from '@components/common';
import ReservationForm from '@components/common/forms/ReservationForm';

const BorrowingEditPage = () => {
    return (
        <EditPage
            modelName="borrowings"
            FormComponent={ReservationForm}
        />
    );
};

export default BorrowingEditPage;
